"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminGradesTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const PortalTypes_1 = require("@common/types/PortalTypes");
const ClassMode_1 = require("../util/ClassMode");
const Markdown_1 = require("../util/Markdown");
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminStudentsTab_1 = require("./AdminStudentsTab");
const AdminView_1 = require("./AdminView");
class AdminGradesTab extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.gradeFor = null;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminGradesTab::init(..) - start");
            document.getElementById("gradesListTable").innerHTML = "";
            document.getElementById("gradesSummaryTable").innerHTML = "";
            const view = AdminGradesTab.selectedView();
            UI_1.UI.showModal("Retrieving grades.");
            const delivs = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            const students = yield AdminStudentsTab_1.AdminStudentsTab.getPeopleForView(this.remote, view);
            const grades = yield AdminGradesTab.getGrades(this.remote, view);
            UI_1.UI.hideModal();
            this.render(grades, delivs, students);
            this.wireViewSelector();
        });
    }
    static selectedView() {
        if (ClassMode_1.ClassMode.isOn() === true) {
            return "students";
        }
        const select = document.querySelector("#gradesViewSelect");
        if (select === null) {
            return "students";
        }
        return PortalTypes_1.PERSON_VIEWS.indexOf(select.value) >= 0 ? select.value : "students";
    }
    wireViewSelector() {
        const select = document.querySelector("#gradesViewSelect");
        if (select === null) {
            return;
        }
        select.onchange = () => {
            this.init({}).catch((err) => {
                Log_1.default.error("AdminGradesTab::wireViewSelector(..) - ERROR: " + err.message);
            });
        };
    }
    render(grades, delivs, students) {
        Log_1.default.trace("AdminGradesTab::render(..) - start");
        const classMode = ClassMode_1.ClassMode.isOn();
        ClassMode_1.ClassMode.show(document.getElementById("gradesListHeader"), classMode === false);
        ClassMode_1.ClassMode.show(document.getElementById("gradesViewItem"), classMode === false);
        if (classMode === true) {
            const list = document.getElementById("gradesListTable");
            if (list !== null) {
                list.innerHTML = "";
            }
            UI_1.UI.hideSection("gradesListTable");
            UI_1.UI.hideSection("gradesListTableNone");
            if (students.length > 0) {
                UI_1.UI.showSection("gradesSummaryTable");
            }
            else {
                UI_1.UI.hideSection("gradesSummaryTable");
            }
            this.renderSummary(grades, delivs, students);
            return;
        }
        const headers = [
            {
                id: "githubId",
                text: "GitHub Id",
                sortable: true,
                defaultSort: true,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "snum",
                text: "SNUM",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "id",
                text: "CSID",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "fName",
                text: "First Name",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "lName",
                text: "Last Name",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "labId",
                text: "Lab",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
            {
                id: "kind",
                text: "Kind",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em;",
            },
        ];
        for (const deliv of delivs) {
            const released = deliv.gradesReleased === true;
            const visible = deliv.visibleToStudents === true;
            const col = {
                id: deliv.id,
                text: deliv.id,
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: right;" + (released && visible ? " text-decoration: underline;" : ""),
                tooltip: "Grades released: " + released + "; Grades visible: " + visible,
            };
            headers.push(col);
        }
        const st = new SortableTable_1.SortableTable(headers, "#gradesListTable");
        st.fitToViewport = false;
        const gradeFor = AdminGradesTab.indexGrades(grades);
        this.gradeFor = gradeFor;
        for (const student of students) {
            const row = [
                {
                    value: student.githubId,
                    html: "<a class='selectable' href='" + student.userUrl + "'>" + student.githubId + "</a>",
                },
                { value: student.studentNum, html: student.studentNum + "" },
                { value: student.id, html: student.id + "" },
                { value: student.firstName, html: student.firstName },
                { value: student.lastName, html: student.lastName },
                { value: student.labId, html: student.labId },
                { value: AdminGradesTab.kindLabel(student), html: AdminGradesTab.kindLabel(student) },
            ];
            for (const deliv of delivs) {
                const grade = gradeFor(student.id, deliv.id);
                row.push(typeof grade === "undefined" ? { value: "", html: "" } : AdminGradesTab.gradeCell(grade));
            }
            st.addRow(row);
        }
        st.generate();
        this.wireFeedback(document.getElementById("gradesListTable"), students);
        if (st.numRows() > 0) {
            UI_1.UI.showSection("gradesListTable");
            UI_1.UI.showSection("gradesSummaryTable");
            UI_1.UI.hideSection("gradesListTableNone");
        }
        else {
            UI_1.UI.hideSection("gradesListTable");
            UI_1.UI.hideSection("gradesSummaryTable");
            UI_1.UI.showSection("gradesListTableNone");
        }
        this.renderSummary(grades, delivs, students);
    }
    static indexGrades(grades) {
        const byPerson = new Map();
        for (const grade of grades) {
            let byDeliv = byPerson.get(grade.personId);
            if (typeof byDeliv === "undefined") {
                byDeliv = new Map();
                byPerson.set(grade.personId, byDeliv);
            }
            byDeliv.set(grade.delivId, grade);
        }
        return (personId, delivId) => { var _a; return (_a = byPerson.get(personId)) === null || _a === void 0 ? void 0 : _a.get(delivId); };
    }
    wireFeedback(container, students) {
        if (container === null || container.dataset.feedbackWired === "true") {
            return;
        }
        container.dataset.feedbackWired = "true";
        const that = this;
        container.addEventListener("click", function (evt) {
            var _a;
            const target = evt.target;
            if (target.closest("a") !== null) {
                return;
            }
            const cell = target.closest("strong.gradeFeedback");
            if (cell === null || that.gradeFor === null) {
                return;
            }
            const grade = that.gradeFor(cell.dataset.personId, cell.dataset.delivId);
            if (typeof grade === "undefined") {
                return;
            }
            const student = students.find((s) => s.id === grade.personId);
            const who = typeof student === "undefined" ? grade.personId : student.githubId;
            let html = Markdown_1.Markdown.render((_a = grade.comment) !== null && _a !== void 0 ? _a : "");
            if (grade.URL !== null) {
                const url = AdminGradesTab.makeHTMLSafe(grade.URL);
                html = `<p><a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a></p>` + html;
            }
            UI_1.UI.showHtmlDialog("Feedback: " + who + " / " + grade.delivId, html);
        });
    }
    static gradeCell(grade) {
        var _a;
        const hoverComment = AdminGradesTab.makeHTMLSafe((_a = grade.comment) !== null && _a !== void 0 ? _a : "");
        let scoreText = "";
        let scorePrepend = "";
        if (grade.score !== null && grade.score >= 0) {
            scoreText = grade.score.toFixed(2);
            if (grade.score < 100) {
                scorePrepend = "&#8199;" + scorePrepend;
                if (grade.score < 10) {
                    scorePrepend = "&#8199;" + scorePrepend;
                }
            }
        }
        let html;
        if (scoreText !== "" && grade.URL !== null) {
            html = scorePrepend + `<a class="selectable" href="${grade.URL}">${scoreText}</a>`;
        }
        else if (scoreText !== "" && grade.URL === null) {
            html = `${scoreText}`;
        }
        else {
            html = scoreText;
        }
        if (hoverComment !== null && hoverComment.length > 1) {
            const personId = AdminGradesTab.makeHTMLSafe(grade.personId);
            const delivId = AdminGradesTab.makeHTMLSafe(grade.delivId);
            html = `<strong class="gradeFeedback" title="${hoverComment}" data-person-id="${personId}" data-deliv-id="${delivId}">${html}</strong>`;
        }
        return { value: scoreText, html };
    }
    renderSummary(grades, delivs, students) {
        Log_1.default.trace("AdminGradesTab::renderSummary(..) - start");
        const st = new SortableTable_1.SortableTable(AdminGradesTab.buildSummaryHeaders(), "#gradesSummaryTable");
        st.fitToViewport = false;
        const gradeMap = AdminGradesTab.collectScoresByDeliv(grades, students);
        const eligible = AdminGradesTab.countEligible(students);
        for (const delivId of Object.keys(gradeMap)) {
            const delivGrades = gradeMap[delivId];
            if (delivGrades.length > 0) {
                st.addRow(AdminGradesTab.buildSummaryRow(delivId, delivGrades, eligible));
            }
        }
        st.generate();
    }
    static buildSummaryHeaders() {
        const headers = [
            {
                id: "delivId",
                text: "Deliv Id",
                sortable: true,
                defaultSort: true,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "avg",
                text: "Average",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "median",
                text: "Median",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "nd",
                text: "N/D",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "009",
                text: "0-9",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "1019",
                text: "10-19",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "2029",
                text: "20-29",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "3039",
                text: "30-39",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "4049",
                text: "40-49",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "5059",
                text: "50-59",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "6069",
                text: "60-69",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "7079",
                text: "70-79",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "8089",
                text: "80-89",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "9099",
                text: "90-99",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "100",
                text: "100",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
        ];
        return headers;
    }
    static collectScoresByDeliv(grades, students) {
        const gradeMap = {};
        const counted = new Set();
        for (const student of students) {
            if (student.labId !== "W") {
                counted.add(student.id);
            }
        }
        for (const grade of grades) {
            if (grade !== null && typeof grade.score !== "undefined" && typeof grade.score === "number") {
                if (typeof gradeMap[grade.delivId] === "undefined") {
                    gradeMap[grade.delivId] = [];
                }
                if (counted.has(grade.personId)) {
                    gradeMap[grade.delivId].push(grade.score);
                }
            }
        }
        return gradeMap;
    }
    static buildSummaryRow(delivId, delivGrades, eligible) {
        const num = delivGrades.length;
        const total = delivGrades.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue;
        });
        const avg = Number((total / num).toFixed(2));
        delivGrades.sort((a, b) => a - b);
        const lowMiddle = Math.floor((num - 1) / 2);
        const highMiddle = Math.ceil((num - 1) / 2);
        let median = (delivGrades[lowMiddle] + delivGrades[highMiddle]) / 2;
        median = Number(median.toFixed(2));
        const numNoData = Math.max(0, eligible - num);
        const row = [
            { value: delivId, html: delivId },
            { value: avg + "", html: avg + "" },
            { value: median + "", html: median + "" },
            { value: numNoData + "", html: numNoData + "" },
        ];
        for (let i = 0; i < 10; i++) {
            const lower = i * 10;
            const upper = lower + 9;
            const numInBin = AdminGradesTab.countInBin(delivGrades, lower, upper);
            Log_1.default.trace("inBin( [..], " + lower + ", " + upper + "; #: " + numInBin);
            row.push({ value: numInBin + "", html: numInBin + "" });
        }
        const numPerfect = AdminGradesTab.countInBin(delivGrades, 100, 100);
        row.push({ value: numPerfect + "", html: numPerfect + "" });
        return row;
    }
    static countEligible(students) {
        let count = 0;
        for (const student of students) {
            if (student.labId !== "W") {
                count++;
            }
        }
        return count;
    }
    static countInBin(list, lower, upper) {
        const total = list.reduce(function (accumulator, currentValue) {
            currentValue = Math.round(currentValue);
            if (currentValue >= lower && currentValue <= upper) {
                accumulator++;
            }
            return accumulator;
        }, 0);
        return total;
    }
    static kindLabel(student) {
        if (typeof student.kind !== "string" || student.kind === "") {
            return "";
        }
        return student.kind;
    }
    static getGrades(remote_1) {
        return __awaiter(this, arguments, void 0, function* (remote, view = "students") {
            Log_1.default.info("AdminGradesTab::getGrades( " + view + " ) - start");
            try {
                const start = Date.now();
                const url = remote + "/portal/admin/grades/" + view;
                const options = AdminView_1.AdminView.getOptions();
                const response = yield fetch(url, options);
                if (response.status === 200) {
                    Log_1.default.trace("AdminGradesTab::getGrades(..) - 200 received");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                        Log_1.default.trace("AdminGradesTab::getGrades(..)  - worked; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminGradesTab::getGrades(..)  - ERROR: " + json.failure.message);
                        AdminView_1.AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminGradesTab::getGrades(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView_1.AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("Getting grades failed: " + err.message);
            }
            return [];
        });
    }
    static makeHTMLSafe(text) {
        return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
}
exports.AdminGradesTab = AdminGradesTab;
